import HomePage from '../_index/route'
export {loader, meta} from '../_index/route'

export const handle = {
  breadcrumb: 'home',
}
export default HomePage
